/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
//
// THIS IS A GENERATED FILE
// DO NOT MODIFY IT! YOUR CHANGES WILL BE LOST
import { Inject, Injectable, Optional } from '@angular/core';
import {
  GrpcCallType,
  GrpcClient,
  GrpcClientFactory,
  GrpcEvent,
  GrpcMetadata
} from '@ngx-grpc/common';
import {
  GRPC_CLIENT_FACTORY,
  GrpcHandler,
  takeMessages,
  throwStatusErrors
} from '@ngx-grpc/core';
import { Observable } from 'rxjs';
import * as thisProto from './paybybank.pb';
import * as googleProtobuf000 from '@ngx-grpc/well-known-types';
import * as googleProtobuf001 from '@ngx-grpc/well-known-types';
import * as comKodypayGrpcCommon002 from '../../../../com/kodypay/grpc/common/money.pb';
import * as options003 from '../../../../options/team.pb';
import { GRPC_PAY_BY_BANK_SERVICE_CLIENT_SETTINGS } from './paybybank.pbconf';
/**
 * Service client implementation for com.kodypay.grpc.paybybank.PayByBankService
 */
@Injectable({ providedIn: 'any' })
export class PayByBankServiceClient {
  private client: GrpcClient<any>;

  /**
   * Raw RPC implementation for each service client method.
   * The raw methods provide more control on the incoming data and events. E.g. they can be useful to read status `OK` metadata.
   * Attention: these methods do not throw errors when non-zero status codes are received.
   */
  $raw = {
    /**
     * Unary call: /com.kodypay.grpc.paybybank.PayByBankService/GetPayByBankCode
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.PayByBankCodeResponse>>
     */
    getPayByBankCode: (
      requestData: thisProto.PayByBankCodeRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.PayByBankCodeResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/com.kodypay.grpc.paybybank.PayByBankService/GetPayByBankCode',
        requestData,
        requestMetadata,
        requestClass: thisProto.PayByBankCodeRequest,
        responseClass: thisProto.PayByBankCodeResponse
      });
    },
    /**
     * Unary call: /com.kodypay.grpc.paybybank.PayByBankService/SubmitPaymentWithInstitutionId
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.TerminalConsentCreationResponse>>
     */
    submitPaymentWithInstitutionId: (
      requestData: thisProto.TerminalConsentCreationRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.TerminalConsentCreationResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path:
          '/com.kodypay.grpc.paybybank.PayByBankService/SubmitPaymentWithInstitutionId',
        requestData,
        requestMetadata,
        requestClass: thisProto.TerminalConsentCreationRequest,
        responseClass: thisProto.TerminalConsentCreationResponse
      });
    },
    /**
     * Unary call: /com.kodypay.grpc.paybybank.PayByBankService/SubmitPaymentAuth
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.SubmitPaymentAuthResponse>>
     */
    submitPaymentAuth: (
      requestData: thisProto.SubmitPaymentAuthRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.SubmitPaymentAuthResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/com.kodypay.grpc.paybybank.PayByBankService/SubmitPaymentAuth',
        requestData,
        requestMetadata,
        requestClass: thisProto.SubmitPaymentAuthRequest,
        responseClass: thisProto.SubmitPaymentAuthResponse
      });
    },
    /**
     * Unary call: /com.kodypay.grpc.paybybank.PayByBankService/ProcessPayment
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.ProcessPaymentResponse>>
     */
    processPayment: (
      requestData: thisProto.ProcessPaymentRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.ProcessPaymentResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/com.kodypay.grpc.paybybank.PayByBankService/ProcessPayment',
        requestData,
        requestMetadata,
        requestClass: thisProto.ProcessPaymentRequest,
        responseClass: thisProto.ProcessPaymentResponse
      });
    },
    /**
     * Unary call: /com.kodypay.grpc.paybybank.PayByBankService/GetPayByBankPayment
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.TerminalPayByBankPaymentResultResponse>>
     */
    getPayByBankPayment: (
      requestData: thisProto.PayByBankPaymentResultRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<
      GrpcEvent<thisProto.TerminalPayByBankPaymentResultResponse>
    > => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path:
          '/com.kodypay.grpc.paybybank.PayByBankService/GetPayByBankPayment',
        requestData,
        requestMetadata,
        requestClass: thisProto.PayByBankPaymentResultRequest,
        responseClass: thisProto.TerminalPayByBankPaymentResultResponse
      });
    },
    /**
     * Unary call: /com.kodypay.grpc.paybybank.PayByBankService/GetInstitutions
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.InstitutionResponse>>
     */
    getInstitutions: (
      requestData: thisProto.InstitutionRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.InstitutionResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/com.kodypay.grpc.paybybank.PayByBankService/GetInstitutions',
        requestData,
        requestMetadata,
        requestClass: thisProto.InstitutionRequest,
        responseClass: thisProto.InstitutionResponse
      });
    },
    /**
     * Unary call: /com.kodypay.grpc.paybybank.PayByBankService/SubmitStoreData
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.StoreResponse>>
     */
    submitStoreData: (
      requestData: thisProto.StoreDataRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.StoreResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/com.kodypay.grpc.paybybank.PayByBankService/SubmitStoreData',
        requestData,
        requestMetadata,
        requestClass: thisProto.StoreDataRequest,
        responseClass: thisProto.StoreResponse
      });
    },
    /**
     * Unary call: /com.kodypay.grpc.paybybank.PayByBankService/GetStoreData
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.StoreResponse>>
     */
    getStoreData: (
      requestData: thisProto.StoreRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.StoreResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/com.kodypay.grpc.paybybank.PayByBankService/GetStoreData',
        requestData,
        requestMetadata,
        requestClass: thisProto.StoreRequest,
        responseClass: thisProto.StoreResponse
      });
    },
    /**
     * Unary call: /com.kodypay.grpc.paybybank.PayByBankService/CancelPayment
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.CancelPaymentResponse>>
     */
    cancelPayment: (
      requestData: thisProto.CancelPaymentRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.CancelPaymentResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/com.kodypay.grpc.paybybank.PayByBankService/CancelPayment',
        requestData,
        requestMetadata,
        requestClass: thisProto.CancelPaymentRequest,
        responseClass: thisProto.CancelPaymentResponse
      });
    },
    /**
     * Unary call: /com.kodypay.grpc.paybybank.PayByBankService/GetPaymentDetails
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.GetPaymentDetailsResponse>>
     */
    getPaymentDetails: (
      requestData: thisProto.GetPaymentDetailsRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.GetPaymentDetailsResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/com.kodypay.grpc.paybybank.PayByBankService/GetPaymentDetails',
        requestData,
        requestMetadata,
        requestClass: thisProto.GetPaymentDetailsRequest,
        responseClass: thisProto.GetPaymentDetailsResponse
      });
    },
    /**
     * Unary call: /com.kodypay.grpc.paybybank.PayByBankService/GetPayByBankPaymentPublic
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.PayByBankPaymentResultResponse>>
     */
    getPayByBankPaymentPublic: (
      requestData: thisProto.PayByBankPaymentResultRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.PayByBankPaymentResultResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path:
          '/com.kodypay.grpc.paybybank.PayByBankService/GetPayByBankPaymentPublic',
        requestData,
        requestMetadata,
        requestClass: thisProto.PayByBankPaymentResultRequest,
        responseClass: thisProto.PayByBankPaymentResultResponse
      });
    },
    /**
     * Unary call: /com.kodypay.grpc.paybybank.PayByBankService/GetPayByBankPaymentRealTimeStatus
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.PayByBankPaymentResultResponse>>
     */
    getPayByBankPaymentRealTimeStatus: (
      requestData: thisProto.PayByBankPaymentResultRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.PayByBankPaymentResultResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path:
          '/com.kodypay.grpc.paybybank.PayByBankService/GetPayByBankPaymentRealTimeStatus',
        requestData,
        requestMetadata,
        requestClass: thisProto.PayByBankPaymentResultRequest,
        responseClass: thisProto.PayByBankPaymentResultResponse
      });
    },
    /**
     * Unary call: /com.kodypay.grpc.paybybank.PayByBankService/GetPayByBankPaymentRealTimeStatusPublic
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.PayByBankPaymentResultResponse>>
     */
    getPayByBankPaymentRealTimeStatusPublic: (
      requestData: thisProto.PayByBankPaymentResultRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.PayByBankPaymentResultResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path:
          '/com.kodypay.grpc.paybybank.PayByBankService/GetPayByBankPaymentRealTimeStatusPublic',
        requestData,
        requestMetadata,
        requestClass: thisProto.PayByBankPaymentResultRequest,
        responseClass: thisProto.PayByBankPaymentResultResponse
      });
    },
    /**
     * Unary call: /com.kodypay.grpc.paybybank.PayByBankService/CreatePaymentAuthorisation
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.AuthCreationResponse>>
     */
    createPaymentAuthorisation: (
      requestData: thisProto.AuthCreationRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.AuthCreationResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path:
          '/com.kodypay.grpc.paybybank.PayByBankService/CreatePaymentAuthorisation',
        requestData,
        requestMetadata,
        requestClass: thisProto.AuthCreationRequest,
        responseClass: thisProto.AuthCreationResponse
      });
    }
  };

  constructor(
    @Optional() @Inject(GRPC_PAY_BY_BANK_SERVICE_CLIENT_SETTINGS) settings: any,
    @Inject(GRPC_CLIENT_FACTORY) clientFactory: GrpcClientFactory<any>,
    private handler: GrpcHandler
  ) {
    this.client = clientFactory.createClient(
      'com.kodypay.grpc.paybybank.PayByBankService',
      settings
    );
  }

  /**
   * Unary call @/com.kodypay.grpc.paybybank.PayByBankService/GetPayByBankCode
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.PayByBankCodeResponse>
   */
  getPayByBankCode(
    requestData: thisProto.PayByBankCodeRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.PayByBankCodeResponse> {
    return this.$raw
      .getPayByBankCode(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/com.kodypay.grpc.paybybank.PayByBankService/SubmitPaymentWithInstitutionId
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.TerminalConsentCreationResponse>
   */
  submitPaymentWithInstitutionId(
    requestData: thisProto.TerminalConsentCreationRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.TerminalConsentCreationResponse> {
    return this.$raw
      .submitPaymentWithInstitutionId(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/com.kodypay.grpc.paybybank.PayByBankService/SubmitPaymentAuth
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.SubmitPaymentAuthResponse>
   */
  submitPaymentAuth(
    requestData: thisProto.SubmitPaymentAuthRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.SubmitPaymentAuthResponse> {
    return this.$raw
      .submitPaymentAuth(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/com.kodypay.grpc.paybybank.PayByBankService/ProcessPayment
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.ProcessPaymentResponse>
   */
  processPayment(
    requestData: thisProto.ProcessPaymentRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.ProcessPaymentResponse> {
    return this.$raw
      .processPayment(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/com.kodypay.grpc.paybybank.PayByBankService/GetPayByBankPayment
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.TerminalPayByBankPaymentResultResponse>
   */
  getPayByBankPayment(
    requestData: thisProto.PayByBankPaymentResultRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.TerminalPayByBankPaymentResultResponse> {
    return this.$raw
      .getPayByBankPayment(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/com.kodypay.grpc.paybybank.PayByBankService/GetInstitutions
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.InstitutionResponse>
   */
  getInstitutions(
    requestData: thisProto.InstitutionRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.InstitutionResponse> {
    return this.$raw
      .getInstitutions(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/com.kodypay.grpc.paybybank.PayByBankService/SubmitStoreData
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.StoreResponse>
   */
  submitStoreData(
    requestData: thisProto.StoreDataRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.StoreResponse> {
    return this.$raw
      .submitStoreData(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/com.kodypay.grpc.paybybank.PayByBankService/GetStoreData
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.StoreResponse>
   */
  getStoreData(
    requestData: thisProto.StoreRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.StoreResponse> {
    return this.$raw
      .getStoreData(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/com.kodypay.grpc.paybybank.PayByBankService/CancelPayment
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.CancelPaymentResponse>
   */
  cancelPayment(
    requestData: thisProto.CancelPaymentRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.CancelPaymentResponse> {
    return this.$raw
      .cancelPayment(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/com.kodypay.grpc.paybybank.PayByBankService/GetPaymentDetails
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.GetPaymentDetailsResponse>
   */
  getPaymentDetails(
    requestData: thisProto.GetPaymentDetailsRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.GetPaymentDetailsResponse> {
    return this.$raw
      .getPaymentDetails(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/com.kodypay.grpc.paybybank.PayByBankService/GetPayByBankPaymentPublic
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.PayByBankPaymentResultResponse>
   */
  getPayByBankPaymentPublic(
    requestData: thisProto.PayByBankPaymentResultRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.PayByBankPaymentResultResponse> {
    return this.$raw
      .getPayByBankPaymentPublic(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/com.kodypay.grpc.paybybank.PayByBankService/GetPayByBankPaymentRealTimeStatus
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.PayByBankPaymentResultResponse>
   */
  getPayByBankPaymentRealTimeStatus(
    requestData: thisProto.PayByBankPaymentResultRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.PayByBankPaymentResultResponse> {
    return this.$raw
      .getPayByBankPaymentRealTimeStatus(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/com.kodypay.grpc.paybybank.PayByBankService/GetPayByBankPaymentRealTimeStatusPublic
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.PayByBankPaymentResultResponse>
   */
  getPayByBankPaymentRealTimeStatusPublic(
    requestData: thisProto.PayByBankPaymentResultRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.PayByBankPaymentResultResponse> {
    return this.$raw
      .getPayByBankPaymentRealTimeStatusPublic(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/com.kodypay.grpc.paybybank.PayByBankService/CreatePaymentAuthorisation
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.AuthCreationResponse>
   */
  createPaymentAuthorisation(
    requestData: thisProto.AuthCreationRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.AuthCreationResponse> {
    return this.$raw
      .createPaymentAuthorisation(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }
}
